<template>
  <div
    :class="['productListcode', { inApp: $root.$data.isApp || this.$root.miniprogram }]"
    id="yd-page5"
  >
    <common-title titleName="课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :offset="20"
          v-if="courseList.length"
          @load="onLoad"
        >
          <ul class="courseList">
            <li v-for="(item, keys) in courseList" :key="keys">
              <CombinationCard v-if="item.setType === 1" :item="item" :index="keys" />
              <HotCourseCard v-else :item="item" :key="keys" />
            </li>
          </ul>
        </van-list>
        <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
        <Foot />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqCombinationlist } from '@/api/combination';
import { reqProducts, reqRelationList } from '@/api/home';
import {deepCopy, loadMantisChat} from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
export default {
  components: {
    CommonTitle,
    HotCourseCard,
    EmptyData,
    Foot,
    CombinationCard,
  },
  data() {
    return {
      courseList: [], // 课程列表
      loading: false,
      finished: true,
      refreshing: false,
      listEmpty: false, // 在loading时不显示缺省页
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    this.getCourse();
  },
  mounted() {
    // 小程序不需要客服
    if (!this.$root.$data?.miniprogram) {
      loadMantisChat(this.userInfo);
    }
  },
  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {},
    // 下拉刷新
    onRefresh() {},
    // 请求产品列表
    async getCourse() {
      sessionStorage.setItem('back', true);
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const { businessCode } = this.$route.query;
      if (!businessCode) {
        this.listEmpty = true;
        this.refreshing = false;
        this.$toast.clear();
        return;
      }
      let res = (await reqRelationList({ code: businessCode })) || [];
      let recommendList = res?.data || [];
      if (recommendList?.length) {
        this.recommendList = recommendList;
        const allProductIds = [];
        const allPackageIds = [];
        recommendList.forEach((item) => {
          if (item.type === 1) {
            allProductIds.push(item.businessId);
          } else {
            allPackageIds.push(item.businessId);
          }
        });
        this.getCourseLists(allProductIds, allPackageIds);
      } else {
        this.listEmpty = true;
        this.refreshing = false;
      }

      this.$toast.clear();
    },
    // 请求精选课程的课程卡片信息
    async getCourseLists(allProductIds, allPackageIds) {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetCourse(res?.data || []);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const courseList = [];
        this.recommendList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.type === 1 ? course.productId : course.packageId;
            return id === Number(child.businessId);
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && courseList.push(findRes);
        });
        if (courseList.length === 0) {
          this.listEmpty = true;
          this.refreshing = false;
          this.$toast.clear();
        }
        this.courseList = courseList;
      });
    },

    resetCourse(majorCourseList) {
      majorCourseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return majorCourseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}

.productListcode {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 100px 36px 0 36px;
  background: #fefeff;

  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }

  .content {
    height: 100%;
  }

  .courseList {
    box-sizing: border-box;
    width: 100%;
    min-height: 98px;
    padding: 20px 0 100px 0;
    background: #fff;
  }

  .courseList > li {
    position: relative;
    width: 686px;
    margin: 0 auto;
    margin-bottom: 25px;
    padding: 0.32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    opacity: 1;

    .liveImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 140px;
      height: 50px;
      border-radius: 0 16px 0 32px;
    }
  }

  ::v-deep .common-foot {
    position: fixed;
  }
}
</style>
